import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 3.7rem;

  @media only screen and (min-width: 768px) {
    margin: 0 29vw;
  }
`;

export const Icon = styled.img`
  margin: 0 auto 5.5rem;
  height: 9.6rem;
  width: 9.6rem;

  @media only screen and (min-width: 768px) {
    height: 14rem;
    width: 14rem;
    margin-bottom: 7rem;
  }
`;

export const Titulo = styled.h1`
  font-style: normal;
  font-weight: 900;
  font-size: 2rem;
  line-height: 3.4rem;
  text-align: center;

  color: ${({ theme }) => theme.colors.PRIMARY};
  margin-bottom: 2.5rem;

  @media only screen and (min-width: 768px) {
    font-size: 2.5rem;
    line-height: 2.765rem;
    letter-spacing: 0em;
    padding: 0 1rem;
  }
`;

export const Texto = styled.span`
  text-align: center;
  font-size: 1.8rem;
  font-weight: ${({ isBold }) => (isBold ? 700 : 600)};
  color: ${({ theme }) => theme.colors.PRIMARY};
  font-style: normal;
  line-height: 3.1rem;
  letter-spacing: 0em;
  text-align: center;

  @media only screen and (min-width: 768px) {
    font-size: 2.2rem;
    line-height: 2.8rem;
    letter-spacing: 0em;
    margin: 0 ${({ isBold }) => (isBold ? 0 : 3)}rem;
  }
`;
